import NSCellInput from 'bricks/NSCellInput/NSCellInput';
import { numeralFormatter } from 'ns_libs/formatter';
import { IResidentialLotMix } from 'views/ProFormaTable/types';

const TD_CLASS = 'NSTable__tbody__tr__td align-middle px-3 py-2';

export interface IPricingRowProps {
    row: IResidentialLotMix;
    onUpdate: (lotMixId: number, dataKey: 'costPerFrontFoot' | 'pricePerLot', value: number | null) => void;
}

const PricingRow = ({ row, onUpdate }: IPricingRowProps) => (
    <tr className="NSTable__tbody__tr NSTable__tbody__tr--level-1">
        <td className={TD_CLASS}>
            {row.lotName ?? ''}
        </td>
        <td className={`${TD_CLASS} text-right`}>
            {numeralFormatter(row.lotWidth, '0,0')}
        </td>
        <td className={`${TD_CLASS} text-right`}>
            <NSCellInput
                value={row.costPerFrontFoot ?? ''}
                handleUpdateValue={value => onUpdate(row.id, 'costPerFrontFoot', value === '' ? null : Number(value))}
                numberType="currency"
                showCents
                placeholder="Enter $ amount"
                isRightAligned
            />
        </td>
        <td className={`${TD_CLASS} text-right`}>
            <NSCellInput
                value={row.pricePerLot ?? ''}
                handleUpdateValue={value => onUpdate(row.id, 'pricePerLot', value === '' ? null : Number(value))}
                numberType="currency"
                showCents
                placeholder="Enter $ amount"
                isRightAligned
            />
        </td>
    </tr>
);

export default PricingRow;
